import { render } from "./HeaderSubComponent.vue?vue&type=template&id=1080f758&scoped=true"
import script from "./HeaderSubComponent.vue?vue&type=script&lang=js"
export * from "./HeaderSubComponent.vue?vue&type=script&lang=js"

import "./HeaderSubComponent.vue?vue&type=style&index=0&id=1080f758&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1080f758"

export default script